import React from 'react';
import { Modal, Offcanvas, Button } from 'react-bootstrap';
import useIsMobile from './useIsMobile';
import './SuccessModal.css';
import { useNavigate } from 'react-router-dom';
import bookingSuccess from '../assets/successAnimation.json';
import Lottie from 'lottie-react';

const SuccessModal = ({ show, onClose }) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const handleRedirect = () => {
    onClose(); // Close modal first
    navigate('/'); // Navigate to bookings page
  };

  const Content = () => (
    <>
        <div className="lottie-wrapper mb-2" style={{ width: 220 }}>
        <Lottie animationData={bookingSuccess} loop={false}  />
      </div>
      <h4 className="mt-3">Booking Confirmed!</h4>
      <p>Your room has been successfully booked. We look forward to your stay!</p>
      <Button className="btn-own mt-2" onClick={handleRedirect}>
        Go to My Bookings
      </Button>
    </>
  );

  return isMobile ? (
    <Offcanvas
      show={show}
      onHide={onClose}
      placement="bottom"
      backdrop={true}
      style={{ height: 'auto', borderRadius: '30px 30px 0 0', borderColor: '#0c609c' }}
    >
      <Offcanvas.Body className="d-flex flex-column justify-content-center align-items-center text-center"
        style={{ padding: '30px', minHeight: '100%' }}>
        <Content />
      </Offcanvas.Body>
    </Offcanvas>
  ) : (
    <Modal show={show} onHide={onClose} centered backdrop="static" style={{borderRadius:'30px'}}>
      <Modal.Body className="text-center">
        <center>
        <Content />
        </center>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessModal;
